import React from 'react';

import {IconGear, IconHandWithSquare, IconHome, IconPeople, IconTools} from '@veneer/core';
import {IconInterface} from '@veneer/core/dist/scripts/icons/types';

import {IconMeta} from '../../../../utils/services/types';
import {IconInitials} from '../IconInitials';

export type ServiceIcons = 'IconHome' | 'IconHandWithSquare' | 'IconTools' | 'IconPeople' | 'IconGear';

export const iconMap: {
    [name in ServiceIcons]: React.JSXElementConstructor<{
        'aria-hidden': true;
        size: IconInterface['size'];
    }>;
} = {
    IconHome: IconHome,
    IconHandWithSquare: IconHandWithSquare,
    IconTools: IconTools,
    IconPeople: IconPeople,
    IconGear: IconGear,
};

const Icon = ({icon}: {icon: IconMeta}) => {
    const size = 24;

    if ('initials' in icon) {
        return (
            <IconInitials
                size={size}
                icon={icon}
            />
        );
    }

    const Icon = iconMap[icon.name];

    return (
        <Icon
            size={size}
            aria-hidden
        />
    );
};

export default Icon;
